import React from 'react'
import styles from './index.module.scss'

interface Props {
  label: JSX.Element | JSX.Element[]
  name: string
  refe: React.LegacyRef<HTMLInputElement>
  checked?: boolean
}
const CheckBoxYellowCesta = ({ label, name, refe, checked }: Props) => {
  return (
    <label className={styles.container}>
      <input
        defaultChecked={checked}
        value={1}
        type="checkbox"
        name={name}
        ref={refe}
      />
      <span className={styles.checkmark}></span>
      {label}
    </label>
  )
}

export default CheckBoxYellowCesta
